import ScreeningReportNavLink from './ScreeningReportNavLink';

export default ScreeningReportNavLink;
